import { Router, NavModel, RouteConfig } from 'aurelia-router';
import { I18N } from 'aurelia-i18n';
import * as moment from 'moment';
import { mock, instance, verify, when, anyNumber, anything, resetCalls } from 'ts-mockito';
import { State } from './global-state';
import { PayrazrService } from './payrazr';
import { MessagesService } from './messages.service';
import { Customer, Account } from '../models/customer';
import { Business } from '../models/business';

describe('NewPortalWeb', () => {
	describe('services', () => {
		describe('messages.service', () => {
			let service: MessagesService;
			const mockBusiness: Business = mock(Business);
			const mockRouter: Router = mock(Router);
			const mockState: State = mock(State);
			const mockPayrazrService: PayrazrService = mock(PayrazrService);
			const mockMessagesService: MessagesService = mock(MessagesService);
			const mockI18N: I18N = mock(I18N);

			// Initialize Component
			beforeEach(() => {
				const accounts = [
					{
						name: 'test1',
						displayName: 'test1',
						portfolioName: 'test1'
					},
					{
						name: 'test2',
						displayName: 'test2',
						portfolioName: 'test2'
					}
				];
				const portfolioSetting = {
					hasSettings: true,
					settings: {
						paymentMethods: {}
					}
				};

				when(mockState.accounts).thenReturn(accounts as Array<Account>);
				when(mockBusiness.fetchPortfolioSettings(anything())).thenReturn(portfolioSetting);
				when(mockState.business).thenReturn(instance(mockBusiness));
				 service = new MessagesService(
					instance(mockPayrazrService),
					instance(mockState),
					instance(mockRouter),
					instance(mockI18N)
				);
			});

			// Mock I18N Dependencies
			beforeEach(() => {
				const i18next = {
					t: (a, b) => a
				};
				when(mockI18N.i18next).thenReturn(i18next);
				spyOn(i18next, 't').and.returnValue('localized');
			});

			it('should initialize component', () => {
				expect(service).toBeTruthy();
				expect(service.accounts.length).toEqual(2);
			});

			describe('markAsRead()', () => {
				let message = {
					messageId: 0,
					readDate: null
				};
				when(mockPayrazrService.markMessageAsRead(anything())).thenResolve();
				it('should mark message as read', () => {
					service.newMessages = 5;
					service.markAsRead(message);
					expect(service.newMessages).toEqual(4);
					expect(message.readDate.locale()).toEqual(moment().locale());
					verify(mockPayrazrService.markMessageAsRead(anything())).called();
				});
			});

			describe('replaceTokensInMessage()', () => {
				let message = {
					messageId: 0,
					message: '',
					hasLink: false,
					linkText: null
				};
				it('should skip messages without documents', () => {
					message.message = '';
					message.hasLink = false;
					message.linkText = null;
					service.replaceTokensInMessage(message);
					expect(message.hasLink).toBeFalsy();
					expect(message.linkText).toBeNull();
				});
				it('should replace document links', () => {
					message.message = 'test {documentlink}';
					service.replaceTokensInMessage(message);
					expect(message.hasLink).toBeTruthy();
					expect(message.linkText).toEqual('localized');
				});

			});

			describe('getMessages()', () => {
				let response = [
					{
						customerAccountReferenceId: 'test1',
						readDate: null,
						message: '',
						hasLink: false,
						linkText: null
					},
					{
						customerAccountReferenceId: 'XYZ',
						readDate: null,
						message: '',
						hasLink: false,
						linkText: null
					}
				];
				when(mockPayrazrService.getMessages()).thenResolve(response);
				it('should only add messages for active accounts', () => {
					service.getMessages().then(() => {
						expect(service.messages.length).toEqual(1);
						expect(service.messages[0]).toEqual(response[0]);
						expect(service.newMessages).toEqual(1);
					});
				});
			});
		});
	});
});
